function plpScrollToProduct() {
  var collectionUrl = getCookie('collectionUrl');
  var collectionProductIndex = getCookie('collectionProductIndex');
  var productTiles = $('#list-plp').find('.plp-product-a');
  var elToScroll;
  // check if url was that for what the position cookie were saved
  if (
    collectionUrl &&
    collectionUrl === window.location.href &&
    collectionProductIndex
  ) {
    // find product to scroll using cookie stored index
    elToScroll = productTiles.eq(Math.abs(collectionProductIndex));
    // erase used cookies
    eraseCookie('collectionUrl');
    eraseCookie('collectionProductIndex');
  } else {
    // find start of last page
    var urlParams = new URLSearchParams(window.location.search);
    var pageIndex = Math.abs(urlParams.get('p')) - 2;
    if (pageIndex > 1) {
      elToScroll = $('.start-page').eq(pageIndex);
    }
  }
  // scroll to product
  if (elToScroll) {
    var announcementBar = $('#shopify-section-section_announcement-bar');
    var announcementBarHeight = announcementBar.length
      ? announcementBar.outerHeight()
      : 0;
    var scrollTo =
      elToScroll.offset().top -
      $('.header-info ').outerHeight() -
      announcementBarHeight;
    window.scroll(0, scrollTo);
  }
}

async function plpGetAjaxProducts(startPage, endPage) {
  for (var currentPage = startPage; currentPage <= endPage; currentPage++) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', currentPage);
    await $.ajax({
      url: url.href,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        var productsToAdd = $(responseHTML).find('#list-plp');
        // add start page class to first element
        productsToAdd.find('.plp-product-a').eq(1).addClass('start-page');
        $('#list-plp').append(productsToAdd.html());
      },
    });
  }
}

function plpLoadMore(startPage, endPage = '', scroll = false) {
  var productGridContainer = $('#ProductGridContainer');
  var maxPages = Math.abs($('[data-all-pages]').val());
  // check max page number is not exceeded
  endPage = endPage || startPage;
  endPage = endPage <= maxPages ? endPage : maxPages;
  // check if loading is still necessary or switch to fully loaded state
  if (startPage <= endPage) {
    // container loading state
    productGridContainer.addClass('loading');
    // make ajax calls
    plpGetAjaxProducts(startPage, endPage).then(function () {
      // update data and texts
      $('.plp-endless-pagination-count').text(
        $('#list-plp').find('.plp-product-a').length,
      );
      $('[data-this-page]').val(endPage);
      $('[data-next-page]').val(endPage + 1);
      // change query parameter to current url
      var url = new URL(window.location.href);
      url.searchParams.set('p', endPage);
      window.history.replaceState(null, null, url);
      // scroll to first product of last page or previously clicked product
      if (scroll) {
        plpScrollToProduct();
      }
      // remove container loading state
      productGridContainer.removeClass('loading');
      // set container fully loaded state if end is reached
      if (endPage >= maxPages) {
        productGridContainer.addClass('fully-loaded');
      }
    });
  } else {
    productGridContainer.addClass('fully-loaded');
  }
}

$(document).ready(function () {
  // check to run only in PLP pages
  var listPlp = $('#list-plp');
  if (listPlp.length) {
    var urlParams = new URLSearchParams(window.location.search);
    var pageIndex = Math.abs(urlParams.get('p'));
    if (pageIndex > 1) {
      plpLoadMore(2, pageIndex, true);
    } else {
      plpScrollToProduct();
    }
  }
});

$(document).on('click', '.custom_loadmore', function () {
  var nextPage = Math.abs($('[data-next-page]').val());
  plpLoadMore(nextPage);
});

// store collection url and clicked product position in cookies on product tile click
$(document).on('click', '.plp-product-a', function (e) {
  var index = $('.plp-product-a').index(e.currentTarget);
  setCookie('collectionProductIndex', index, 1);
  setCookie('collectionUrl', window.location.href, 1);
});
